import React, {useState, useEffect, useCallback} from 'react'
import { ContainerWithPic, DetailsTitle, GenericContainer, Overlay, Strong } from '../../GlobalStyles';
import styled from 'styled-components';
import Gallery from "react-photo-gallery";
import SelectedImage from './SelectedImage';

const TestContainer = styled(GenericContainer)`
    max-width: 100%;
`;

const Portfolio = () => {

  const [photos, setPhotos] = useState(null);

  const getData = () => {
    fetch('gallery.json'
        , {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        }
    ).then(function(response){
        return response.json();
    })
    .then(function(myJson) {
        setPhotos(myJson.photos);
        console.log(photos);
    });
  }
  useEffect(() => {
    getData()
  }, [])

  const TContainer = styled.div`
    @media (max-width: 900px){
      margin-top: 6rem;
    }
  `;

  const imageRenderer = useCallback(
    ({ index, left, top, key, photo }) => (
      <>
        <SelectedImage
          src={key}
          margin={"2px"}
          index={index}
          photo={photo}
          left={left}
          top={top}
        />
      </>
    ),
    []
  );

    return (
      <TContainer>
        {
          photos && 
            <ContainerWithPic>
              <Overlay />
                <TestContainer large>
                    <DetailsTitle style={{paddingBottom: "3rem"}} center>Our<Strong> Portfolio</Strong></DetailsTitle>
                    <Gallery photos={photos} direction={"column"} renderImage={imageRenderer}/>
                </TestContainer>
            </ContainerWithPic>
        }
      </TContainer>
    )
}

export default Portfolio